import { ChangeDetectionStrategy, Component, computed, EventEmitter, input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DatePickerModule } from 'primeng/datepicker';

@Component({
  selector: 'tf-date-input',
  standalone: true,
  imports: [FormsModule, DatePickerModule],
  template: `
    <p-datepicker
      [inputId]="inputId()"
      [placeholder]="placeholder()"
      [ngModel]="dateValue()"
      (ngModelChange)="onDateChange($event)"
      appendTo="body"
      [invalid]="invalid()"
      class="w-full"
    />
  `,
  styles: ':host { display: block; width: 100%; }',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DateInputComponent {
  readonly value = input<string>('');
  readonly placeholder = input<string>('');
  readonly inputId = input<string>('tf-date-input');
  readonly invalid = input<boolean>(false);
  @Output() readonly valueChange = new EventEmitter<string>();

  readonly dateValue = computed<Date | null>(() => {
    const str = this.value();
    if (!str || str === '') return null;
    const d = new Date(str);
    return isNaN(d.getTime()) ? null : d;
  });

  onDateChange(date: Date | null): void {
    if (!date) {
      this.valueChange.emit('');
      return;
    }
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    this.valueChange.emit(`${y}-${m}-${d}`);
  }
}
